import axiosInstance from '../../services/api';

/**
 * Base service class for entity operations
 */
class BaseEntityService {

  /**
   * Generic filter entities method
   * @param {string} endpoint - API endpoint
   * @param {Object} params - Filter parameters
   * @returns {Promise} API response promise
   */
  static async filterEntities(endpoint, params = {}) {
    const processedParams = this.processArrayParams(params);

    const { data } = await axiosInstance.get(`${endpoint}/filter/`, {
      params: processedParams,
    });

    return data;
  }

  /**
   * Get single entity by identifier
   * @param {string} endpoint - API endpoint
   * @param {string|number} identifier - Entity identifier
   * @param {string} queryParams - Optional query parameters
   * @returns {Promise} API response promise
   */
  static async getEntity(endpoint, identifier, queryParams = '') {
    const { data } = await axiosInstance.get(`${endpoint}/${identifier}/${queryParams}`);
    return data;
  }

  /**
   * Process array parameters for API requests
   * @param {Object} params - Raw parameters
   * @returns {Object} Processed parameters
   */
  static processArrayParams(params) {
    const processedParams = {};

    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        processedParams[key] = value.join(',');
      } else if (value !== null && value !== undefined && value !== '') {
        processedParams[key] = value;
      }
    });

    return processedParams;
  }

  /**
   * Create query key for React Query
   * @param {string} entityType - Type of entity
   * @param {Object} params - Query parameters
   * @returns {Array} Query key array
   */
  static createQueryKey(entityType, params = {}) {
    return [entityType, 'filter', params];
  }

  /**
   * Create detail query key for React Query
   * @param {string} entityType - Type of entity
   * @param {string|number} identifier - Entity identifier
   * @returns {Array} Query key array
   */
  static createDetailQueryKey(entityType, identifier) {
    return [entityType, 'detail', identifier];
  }
}

export default BaseEntityService;